@if (visibleItems.length) {
  <div class="summary-wrapper">
    <div class="summary-scroll">
      @for (item of visibleItems; track $index) {
        @let display = resolveDisplay(item);

        <div class="summary-card">
          @if (item.icon) {
            <div class="summary-icon">
              <i class="pi" [ngClass]="item.icon"></i>
            </div>
          }

          <div class="summary-content">
            <div class="summary-title" [title]="item.title">
              {{ item.title }}
            </div>

            <div
              class="summary-value"
              [pTooltip]="display.tooltip ?? ''"
              tooltipPosition="top"
              [tooltipDisabled]="!display.tooltip"
            >
              @if (display.isComposite) {
                <span class="summary-value-composite">
                  <span class="summary-value-main">{{ display.value }}</span>
                  <span class="summary-value-separator">/</span>
                  <span class="summary-value-limit">{{ display.limit }}</span>
                </span>
              } @else {
                {{ display.value }}
              }
            </div>
          </div>
        </div>
      }
    </div>
  </div>
}
